export default "__VITE_ASSET__CBB1dOC4__"